import { Question } from '@playbooks/core/src/interfaces'

import { IInputNode, BaseNode } from '../../../actionCard'

export class QuestionNode extends BaseNode implements IInputNode<any> {
  declare data: Question

  public getCode(): string | undefined | null {
    return this.data.code
  }

  public getLabelTemplate(): string {
    return this.data.text
  }

  public getType(): string {
    return this.data.type
  }

  public get IInputNode(): boolean {
    return true
  }

  public getValue(): any {
    return this.data.value
  }

  public setValue(value?: any): void {
    const oldValue = this.getValue()
    this.data.value = value
    const newValue = this.getValue()

    this.nodeSettings?.observer?.onValueSet?.(this, newValue, oldValue)
  }

  public getStringValue(): string {
    return this.getValue()?.toString?.() ?? ''
  }

  public setStringValue(value?: string): void {
    this.setValue(value)
  }

  public stringifyValue(): string {
    return this.getStringValue()
  }

  public isInputEmpty(): boolean {
    return !this.getValue()
  }
}
